import React, { useEffect } from "react";
import {
  BoxesContainer,
  GetStartedButton,
  SubscriptionBox,
  SubscriptionMessage,
  SubscriptionTitle,
  WelcomeBox,
  WelcomeSubtitle,
  WelcomeTitle,
} from "./styles";
import { Layout } from "components/Layout.tsx/Layout";
import { Footer } from "components/Footer/Footer";
import { useAuth } from "context/AuthContext";
import { getRemainingDays } from "utils/helpers";

export const Dashboard: React.FC = () => {
  const [remainingDays, setRemainingDays] = React.useState(0);
  // TODO: Implement the logic to check if the subscription is active
  // const { auth, clearToken } = useAuth();
  const subscriptionActive = true;

  const { auth } = useAuth();

  useEffect(() => {
    if (auth?.user) {
      setRemainingDays(getRemainingDays(auth.user.expireAt));
    }
  }, [auth]);

  return (
    <Layout>
      <BoxesContainer>
        <WelcomeBox>
          <WelcomeTitle>Welcome, {auth?.user?.username} !</WelcomeTitle>
          <WelcomeSubtitle>We're glad to see you back.</WelcomeSubtitle>
          <GetStartedButton to="/getting-started">
            Getting Started
          </GetStartedButton>
        </WelcomeBox>
        <SubscriptionBox>
          {remainingDays > 0 ? (
            <>
              <SubscriptionTitle>Your Subscription</SubscriptionTitle>
              <SubscriptionMessage>
                Your subscription plan is <b>Active</b>. You still have{" "}
                {remainingDays} days
              </SubscriptionMessage>
            </>
          ) : (
            <>
              <SubscriptionTitle>Subscription Ended</SubscriptionTitle>
              <SubscriptionMessage>
                Your subscription has <b>ended</b>. Please renew to continue
                enjoying our services.
              </SubscriptionMessage>
            </>
          )}
        </SubscriptionBox>
      </BoxesContainer>
      <Footer />
    </Layout>
  );
};
